export default __webpack_public_path__ + "static/media/farming.324781db.png";